import axios from 'axios'
import gaEvent, { gaPageView } from 'utilities/tracking'
import {
  API_PAYMENT_URL,
  API_ORDER_SUMMARY_URL,
  API_TRANSITION_URL,
} from './constants'

export const IS_LOADING = 'IS_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const PAYMENT_PROCESSING = 'PAYMENT_PROCESSING'
export const PAYMENT_ERROR = 'PAYMENT_ERROR'
export const PAYMENT_DECLINED = 'PAYMENT_DECLINED'
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS'
export const ORDER_SUMMARY_FETCH_SUCCESS = 'ORDER_SUMMARY_FETCH_SUCCESS'
export const ORDER_SUMMARY_FETCH_FAILURE = 'ORDER_SUMMARY_FETCH_FAILURE'
export const STAGE_TRANSITION_SUCCESS = 'STAGE_TRANSITION_SUCCESS'

export function isLoading(state) {
  return { type: IS_LOADING, payload: state }
}

export function setError(on) {
  return { type: SET_ERROR, payload: on }
}

export function paymentSetError(error) {
  return { type: PAYMENT_ERROR, payload: { error } }
}

export function paymentSetDeclined(declined) {
  return { type: PAYMENT_DECLINED, payload: { declined } }
}

export function paymentSuccess(nextStage) {
  return { type: PAYMENT_SUCCESS, payload: nextStage }
}

export function paymentSetProcessing() {
  return { type: PAYMENT_PROCESSING }
}

export function paymentSubmit(requestId, nonce) {
  return (dispatch) => {
    dispatch(paymentSetProcessing(true))
    const data = { reqid: requestId, nonce }
    axios
      .post(API_PAYMENT_URL, data)
      .then((response) => {
        if (response.data.success) {
          dispatch(paymentSuccess(response.data.next))
        } else if (response.data.response !== undefined) {
          dispatch(paymentSetDeclined(true))
          gaEvent('Declined', {
            event_category: 'Payment',
            event_label: 'Pay Details Declined',
          })
        } else {
          dispatch(paymentSetError(true))
          gaEvent('Error', {
            event_category: 'Payment',
            event_label: 'Pay Network Error',
          })
        }
      })
      .catch(() => {
        dispatch(paymentSetError(true))
        gaEvent('Error', {
          event_category: 'Payment',
          event_label: 'Pay Network Error',
        })
      })
  }
}

function orderSummarySuccess(payload) {
  return { type: ORDER_SUMMARY_FETCH_SUCCESS, payload }
}

function orderSummaryFailure(payload) {
  return { type: ORDER_SUMMARY_FETCH_FAILURE, payload }
}

export function fetchOrderSummary() {
  return (dispatch) => {
    dispatch(isLoading(true))
    axios
      .get(API_ORDER_SUMMARY_URL)
      .then((response) => {
        dispatch(orderSummarySuccess(response.data))
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          window.location.href = '/'
        } else {
          dispatch(orderSummaryFailure())
          gaEvent('Error', {
            event_category: 'Fetch Order Summary',
            event_label: 'Network Error',
            non_interaction: true,
          })
        }
      })
  }
}

function stageTransitionSuccess(payload) {
  return { type: STAGE_TRANSITION_SUCCESS, payload }
}

export function transitionToStage(stage) {
  return (dispatch) => {
    dispatch(isLoading(true))
    axios
      .post(API_TRANSITION_URL, { target_state: stage })
      .then((response) => {
        dispatch(stageTransitionSuccess(response.data))
        gaPageView(stage)
      })
      .catch((error) => {
        dispatch(setError(true))
        dispatch(isLoading(false))
        gaEvent('Error', {
          event_category: 'Transition',
          event_label: (error.response && error.response.statusText) || 'Network Error',
          non_interaction: true,
        })
      })
  }
}



// WEBPACK FOOTER //
// ./containers/Checkout/actions.js